var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { prevent } from '../../../common/utils';
export function cleanProps(props) {
    var select = props.select, filterKey = props.filterKey, mode = props.mode, optionKey = props.displayKey, options = props.options, selectedKey = props.selectedKey, listKey = props.listKey, referenceKey = props.referenceKey, optionsAsync = props.optionsAsync, rest = __rest(props, ["select", "filterKey", "mode", "displayKey", "options", "selectedKey", "listKey", "referenceKey", "optionsAsync"]);
    var inputProps = rest;
    if (typeof inputProps.panel === 'undefined')
        inputProps.panel = true;
    if (typeof inputProps.chevron === 'undefined')
        inputProps.chevron = true;
    return inputProps;
}
export function getIndex(options, displayIndex, event) {
    if (event.key === Keys.ArrowUp) {
        prevent(event);
        if (displayIndex === null) {
            return options.length - 1;
        }
        else if (options[displayIndex - 1]) {
            return displayIndex - 1;
        }
        else {
            return 0;
        }
    }
    else if (event.key === Keys.ArrowDown) {
        prevent(event);
        if (displayIndex === null) {
            return 0;
        }
        else if (options[displayIndex + 1]) {
            return displayIndex + 1;
        }
        else {
            return options.length - 1;
        }
    }
}
export function getSelected(options, index, item) {
    if (typeof index !== 'number')
        index = options.findIndex(function (option) { return option === item; });
    if (options[index]) {
        return {
            index: index,
            selected: item,
        };
    }
}
export function getNested(key, item) {
    if (typeof key === 'string') {
        var value = key.split('.').reduce(function (obj, key) { return obj[key]; }, item);
        if (value) {
            return String(value);
        }
        return '';
    }
    else if (Array.isArray(key)) {
        var value = key.map(function (k) { return k.split('.').reduce(function (obj, key) { return obj[key]; }, item); });
        if (value) {
            return String(value);
        }
        return [];
    }
}
export function getOptions(data) {
    if (Array.isArray(data)) {
        return data;
    }
    else if (Array.isArray(data === null || data === void 0 ? void 0 : data['items'])) {
        return data.items;
    }
    else if (Array.isArray(data === null || data === void 0 ? void 0 : data['Items'])) {
        return data.Items;
    }
    return [];
}
export var formatFindedString = function (search, text, options) {
    if (options === void 0) { options = {}; }
    var _a = (options || {}), bold = _a.bold, color = _a.color;
    search = search.toLowerCase();
    var idx = text.toLowerCase().indexOf(search);
    if (idx >= 0) {
        var sub = text.substring(idx, idx + search.length);
        if (bold !== false)
            text = text.replace(sub, "<b>".concat(sub, "</b>"));
        if (color)
            text = text.replace(sub, "<span style=\"color:".concat(color, "\">").concat(sub, "</span>"));
    }
    return text;
};
